import React, { Component } from 'react';
import './Loading.css';

export default class Loading extends Component {
  render() {
    return < div class="loading" id={this.props.active} />
  }
};